import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {AppsService} from '../../../../../core/services/apps.service';
import {SessionService} from '../../../../../core/services/session.service';
import {UrlService} from '../../../../../core/services/url.service';
import {NgClass} from '@angular/common';
import { DialogBoxButtonColor } from 'src/shared/models/dialog-box';

@Component({
  selector: 'motn-apps-new',
  templateUrl: './apps-new.component.html',
  styleUrls: ['./apps-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
  ],
})
export class AppsNewComponent implements OnInit {
  sampleTileIcons: { icon: string, color: string }[] = [
    {icon: 'toggle-on', color: 'indigo'},
    {icon: 'fan', color: 'green'},
    {icon: 'toggle-off', color: 'indigo-black'},
    {icon: 'warning', color: 'yellow'},
    {icon: 'chart-line', color: 'green-black'},
    {icon: 'droplet-degree', color: 'indigo'},
    {icon: 'leaf', color: 'green'},
    {icon: 'fire', color: 'red'},
    {icon: 'folder', color: 'white'},
  ];


  constructor(
    private appsService: AppsService,
    private shadeTools: ShadeToolsService,
    private session: SessionService,
    private router: Router,
  ) {
  }


  ngOnInit(): void {
  }


  createMosaic() {
    this.shadeTools.startDialog(
      `New App`,
      `Provide a name for your new Mosaic app. It can be changed later as well.`,
      [
        {
          text: 'Create App',
          callback: (input: string) => {
            this.appsService.createApp$({
              Owner: this.session.userId,
              Name: input.trim(),
              Type: 'picture',
              Config: {
                Subtitle: {
                  Text: '',
                },
                Location: {
                  PostalCode: '',
                },
              },
            }).subscribe({
              next: (app) => {
                this.shadeTools.closeAll();
                // Navigate to the newly created app's mosaic dashboard
                const dashboardUrl = UrlService.makeMosaicDashboardUrl(app.ID);
                this.router.navigateByUrl(dashboardUrl);
              },
              error: () => {
                this.shadeTools.errorDialog();
              },
            });
          },
          callbackIsDefault: true,
          color: DialogBoxButtonColor.Green,
        },
        {
          text: 'Cancel',
          callback: () => {
            this.shadeTools.closeAll();
          },
          color: DialogBoxButtonColor.Alt,
        },
      ],
      true,
      false,
      false,
      false,
    );
  }
}
